const GOOGLE_TAG_ID = "AW-965127179";
const GOOGLE_TAG_ORIGIN = "https://www.googletagmanager.com";
const GOOGLE_TAG_CONFIG = {
  anonymize_ip: true,
  cookie_expires: 0,
  send_page_view: false,
};

let dataLayerReady = false;
let scriptScheduled = false;
let scriptRequested = false;
let lastPagePath;

const isBrowser =
  typeof window !== "undefined" && typeof document !== "undefined";

const canTrack = () => isBrowser && process.env.NODE_ENV === "production";

const ensureDataLayer = () => {
  if (!canTrack()) {
    return false;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  if (!dataLayerReady) {
    window.gtag("consent", "default", {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
    });

    window.gtag("set", "linker", {
      domains: ["salesbinder.com", "app.salesbinder.com"],
    });
    window.gtag("js", new Date());
    window.gtag("config", GOOGLE_TAG_ID, GOOGLE_TAG_CONFIG);
    dataLayerReady = true;
  }

  return true;
};

const injectGoogleTag = () => {
  if (scriptRequested || !canTrack()) {
    return;
  }

  scriptRequested = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `${GOOGLE_TAG_ORIGIN}/gtag/js?id=${GOOGLE_TAG_ID}`;
  document.head.appendChild(script);
};

export const initializeGoogleTag = () => {
  if (!ensureDataLayer() || scriptScheduled) {
    return;
  }

  scriptScheduled = true;

  const loadAfterInteraction = () => injectGoogleTag();
  const interactionEvents = ["pointerdown", "keydown", "touchstart", "scroll"];

  interactionEvents.forEach((eventName) => {
    window.addEventListener(eventName, loadAfterInteraction, {
      once: true,
      passive: true,
    });
  });

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(injectGoogleTag, { timeout: 2000 });
    return;
  }

  window.addEventListener(
    "load",
    () => {
      window.setTimeout(injectGoogleTag, 1500);
    },
    { once: true },
  );
};

export const trackGooglePageView = (location) => {
  if (!ensureDataLayer()) {
    return;
  }

  initializeGoogleTag();

  const pagePath = location
    ? `${location.pathname}${location.search}${location.hash}`
    : undefined;

  if (!pagePath || pagePath === lastPagePath) {
    return;
  }

  lastPagePath = pagePath;
  window.gtag("event", "page_view", { page_path: pagePath });
};
